import { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import PdfViewerContainer from "../../../components/PdfViewerContainer";

const SELECT = "SELECT";
const FORM_NAME = "SBI_CA2";
const PDF_ENDPOINT = "/FillMyForm/SBI_CA2/CurrentPrint.php";
const GROUPS = [
  {
    "title": "Entity Details",
    "fields": [
      {
        "name": "acno",
        "label": "Account Number",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "numeric": true
      },
      {
        "name": "enttype",
        "label": "Entity Constituion Type",
        "type": "select",
        "required": true,
        "options": [
          [
            "PFIRM",
            "Partnership Firm"
          ],
          [
            "HUF",
            "HUF"
          ],
          [
            "PRIVATELTD",
            "Private Limited Company"
          ],
          [
            "PUBLICLTD",
            "Public Limited Company"
          ],
          [
            "SOCIETY",
            "Society"
          ],
          [
            "AOP",
            "Association of Persons AOP / Body of Indivisuals (BOI)"
          ],
          [
            "TRUST",
            "Trust"
          ],
          [
            "GOVT",
            "Government Departments / Agengy"
          ],
          [
            "OTHERS",
            "Othes"
          ]
        ]
      },
      {
        "name": "entname",
        "label": "Entity Name",
        "type": "text",
        "required": true,
        "maxLength": 74,
        "alphaOnly": true
      },
      {
        "name": "entdoi",
        "label": "Date of Incorporation / Formation",
        "type": "date",
        "required": true,
        "maxLength": null
      },
      {
        "name": "entpan",
        "label": "PAN Number (Entity)",
        "type": "text",
        "required": false,
        "maxLength": 10,
        "uppercase": true
      },
      {
        "name": "gstn",
        "label": "GST Number",
        "type": "text",
        "required": false,
        "maxLength": 15,
        "uppercase": true
      },
      {
        "name": "poi",
        "label": "Proof of Identity",
        "type": "select",
        "required": true,
        "options": [
          [
            "COI",
            "Certificate of Incorporation / Formation"
          ],
          [
            "RC",
            "Registration Certificate"
          ],
          [
            "PDEED",
            "Partnership Deed"
          ],
          [
            "TDEED",
            "Trust Deed"
          ],
          [
            "MAA",
            "Memorandum and Article of Association"
          ],
          [
            "OVD",
            "Officially Valid document(s) In Respect of Person Authorized to Transact"
          ],
          [
            "ROB",
            "Resolution Of Board / Managing Committee"
          ],
          [
            "POT",
            "Power of Attorny Granted to Its Manager, Officer Employees to Transact on Its behalf"
          ],
          [
            "OTHER",
            "Other"
          ]
        ]
      },
      {
        "name": "norp",
        "label": "Number of Related Persons",
        "type": "select",
        "required": true,
        "options": [
          [
            "1",
            "1"
          ],
          [
            "2",
            "2"
          ]
        ]
      },
      {
        "name": "nob",
        "label": "Nature of Business",
        "type": "select",
        "required": true,
        "options": [
          [
            "MANUFACTURER",
            "MANUFACTURER"
          ],
          [
            "TRADER",
            "TRADER"
          ],
          [
            "RETAILER",
            "RETAILER"
          ],
          [
            "SP",
            "SERVICE PROVIDER"
          ],
          [
            "EXPORT",
            "EXPORT / IMPORT"
          ],
          [
            "OTHERS",
            "OTHERS"
          ]
        ]
      },
      {
        "name": "turnover",
        "label": "Turn Over",
        "type": "select",
        "required": true,
        "options": [
          [
            "0_5",
            "0 - 5 LAKH"
          ],
          [
            "5_10",
            "5 - 10 LAKH"
          ],
          [
            "10_25",
            "10 - 25 LAKH"
          ],
          [
            "25_1CR",
            "25 LAKH - 1 CR"
          ],
          [
            "1CR_5CR",
            "25 CR - 5 CR"
          ],
          [
            "5CR_50CR",
            "5 CR - 50 CR"
          ],
          [
            "50CR_100CR",
            "50 CR - 100 CR"
          ]
        ]
      }
    ]
  },
  {
    "title": "Entity Address",
    "fields": [
      {
        "name": "entadd1",
        "label": "Address Line1",
        "type": "text",
        "required": true,
        "maxLength": 40
      },
      {
        "name": "entadd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 40
      },
      {
        "name": "entadd3",
        "label": "Address Line 3",
        "type": "text",
        "required": true,
        "maxLength": 22
      },
      {
        "name": "entcity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "entdist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 23
      },
      {
        "name": "entstate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "entpin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 6,
        "numeric": true
      },
      {
        "name": "entmobile",
        "label": "Mobile",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "numeric": true
      },
      {
        "name": "entemail",
        "label": "Email",
        "type": "text",
        "required": false,
        "maxLength": 37
      }
    ]
  },
  {
    "title": "First Person Details",
    "fields": [
      {
        "name": "faname",
        "label": "Applicant Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "fadob",
        "label": "Date of Birth",
        "type": "date",
        "required": true,
        "maxLength": null
      },
      {
        "name": "fagender",
        "label": "Gender",
        "type": "select",
        "required": true,
        "options": [
          [
            "MALE",
            "MALE"
          ],
          [
            "FEMALE",
            "FEMALE"
          ]
        ]
      },
      {
        "name": "famstatus",
        "label": "Marital Status",
        "type": "select",
        "required": true,
        "options": [
          [
            "MARRIED",
            "MARRIED"
          ],
          [
            "UNMARRIED",
            "UNMARRIED"
          ]
        ]
      },
      {
        "name": "faaadhaarno",
        "label": "Aadhaar Number",
        "type": "text",
        "required": true,
        "maxLength": 12,
        "numeric": true
      },
      {
        "name": "fapan",
        "label": "PAN Number",
        "type": "text",
        "required": false,
        "maxLength": 10,
        "uppercase": true
      },
      {
        "name": "fafname",
        "label": "Father's Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "fasname",
        "label": "Spouse Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "famname",
        "label": "Mother's Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      }
    ]
  },
  {
    "title": "First Person Address",
    "fields": [
      {
        "name": "faadd1",
        "label": "Address Line 1",
        "type": "text",
        "required": true,
        "maxLength": 37
      },
      {
        "name": "faadd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 37
      },
      {
        "name": "faadd3",
        "label": "Address Line 3",
        "type": "text",
        "required": true,
        "maxLength": 22
      },
      {
        "name": "facity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "fadist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 23
      },
      {
        "name": "fastate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "fapin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 6,
        "numeric": true
      },
      {
        "name": "fabplace",
        "label": "Bith Place",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "famobile",
        "label": "Mobile",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "numeric": true
      },
      {
        "name": "faoccupation",
        "label": "Occupation",
        "type": "select",
        "required": true,
        "options": [
          [
            "SERVICE",
            "SERVICE"
          ],
          [
            "PUBLIC_SECTOR",
            "PUBLIC SECTOR"
          ],
          [
            "PRIVATE_SECTOR",
            "PRIVATE SECTOR"
          ],
          [
            "GOVERNMET_SECTOR",
            "GOVERNMET_SECTOR"
          ],
          [
            "OTHERS",
            "OTHERS"
          ],
          [
            "PROFESSIONAL",
            "PROFESSIONAL"
          ],
          [
            "SELF_EMPLOYED",
            "SELF EMPLOYED"
          ],
          [
            "RETIRED",
            "RETIRED"
          ],
          [
            "HOUSEWIFE",
            "HOUSEWIFE"
          ],
          [
            "STUDENT",
            "STUDENT"
          ],
          [
            "BUSINESS",
            "BUSINESS"
          ],
          [
            "NOT_CATEGORIZED",
            "NOT_CATEGORISED"
          ]
        ]
      }
    ]
  },
  {
    "title": "Second Person Details",
    "fields": [
      {
        "name": "saname",
        "label": "Applicant Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "sadob",
        "label": "Date of Birth",
        "type": "date",
        "required": true,
        "maxLength": null
      },
      {
        "name": "sagender",
        "label": "Gender",
        "type": "select",
        "required": true,
        "options": [
          [
            "MALE",
            "MALE"
          ],
          [
            "FEMALE",
            "FEMALE"
          ]
        ]
      },
      {
        "name": "samstatus",
        "label": "Marital Status",
        "type": "select",
        "required": true,
        "options": [
          [
            "MARRIED",
            "MARRIED"
          ],
          [
            "UNMARRIED",
            "UNMARRIED"
          ]
        ]
      },
      {
        "name": "saaadhaarno",
        "label": "Aadhaar Number",
        "type": "text",
        "required": true,
        "maxLength": 12,
        "numeric": true
      },
      {
        "name": "sapan",
        "label": "PAN Number",
        "type": "text",
        "required": false,
        "maxLength": 10,
        "uppercase": true
      },
      {
        "name": "safname",
        "label": "Father's Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "sasname",
        "label": "Spouse Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      },
      {
        "name": "samname",
        "label": "Mother's Name",
        "type": "text",
        "required": true,
        "maxLength": 32,
        "alphaOnly": true
      }
    ]
  },
  {
    "title": "Second Person Address",
    "fields": [
      {
        "name": "saadd1",
        "label": "Address Line 1",
        "type": "text",
        "required": true,
        "maxLength": 37
      },
      {
        "name": "saadd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 37
      },
      {
        "name": "saadd3",
        "label": "Address Line 3",
        "type": "text",
        "required": true,
        "maxLength": 22
      },
      {
        "name": "sacity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "sadist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 23
      },
      {
        "name": "sastate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "sapin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 6,
        "numeric": true
      },
      {
        "name": "sabplace",
        "label": "Bith Place",
        "type": "text",
        "required": true,
        "maxLength": 13
      },
      {
        "name": "samobile",
        "label": "Mobile",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "numeric": true
      },
      {
        "name": "saoccupation",
        "label": "Occupation",
        "type": "select",
        "required": true,
        "options": [
          [
            "SERVICE",
            "SERVICE"
          ],
          [
            "PUBLIC_SECTOR",
            "PUBLIC SECTOR"
          ],
          [
            "PRIVATE_SECTOR",
            "PRIVATE SECTOR"
          ],
          [
            "GOVERNMET_SECTOR",
            "GOVERNMET_SECTOR"
          ],
          [
            "OTHERS",
            "OTHERS"
          ],
          [
            "PROFESSIONAL",
            "PROFESSIONAL"
          ],
          [
            "SELF_EMPLOYED",
            "SELF EMPLOYED"
          ],
          [
            "RETIRED",
            "RETIRED"
          ],
          [
            "HOUSEWIFE",
            "HOUSEWIFE"
          ],
          [
            "STUDENT",
            "STUDENT"
          ],
          [
            "BUSINESS",
            "BUSINESS"
          ],
          [
            "NOT_CATEGORIZED",
            "NOT_CATEGORISED"
          ]
        ]
      }
    ]
  }
];

const allSourceFields = GROUPS.flatMap((group) => group.fields);
const initialFormData = Object.fromEntries(
  allSourceFields.map((field) => [field.name, field.type === "select" ? SELECT : ""])
);


async function readJson(response) {
  const text = await response.text();
  if (!text.trim()) return null;
  try { return JSON.parse(text); } catch { throw new Error("The server returned invalid JSON."); }
}

export default function Current() {
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [currentTab, setCurrentTab] = useState(0);
  const [maxAllowedTab, setMaxAllowedTab] = useState(0);
  const [pdfUrl, setPdfUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const nextButtonRef = useRef(null);

  const hasSecondPerson = formData.norp === "2";
  const tabs = useMemo(() => GROUPS.filter((group) => {
    if (["Second Person Details","Second Person Address"].includes(group.title)) return hasSecondPerson;
    return true;
  }), [hasSecondPerson]);

  const activeTab = tabs[currentTab] || tabs[0];
  const currentFields = activeTab?.fields || [];

  const isDisabled = (field) => {
    if (field.name === "fasname" && formData.famstatus === "UNMARRIED") return true;
    if (field.name === "sasname" && formData.samstatus === "UNMARRIED") return true;
    return false;
  };

  const enabledFields = currentFields.filter((field) => !isDisabled(field));

  useEffect(() => {
    if (currentTab >= tabs.length) setCurrentTab(Math.max(0, tabs.length - 1));
  }, [currentTab, tabs.length]);

  useEffect(() => {
    const first = enabledFields[0];
    if (!first) return;
    const frame = requestAnimationFrame(() => document.getElementById(first.name)?.focus());
    return () => cancelAnimationFrame(frame);
  }, [currentTab, tabs.length]);

  useEffect(() => {
    if (formData.famstatus === "UNMARRIED") setFormData((p) => ({ ...p, fasname: "" }));
  }, [formData.famstatus]);

  useEffect(() => {
    if (formData.samstatus === "UNMARRIED") setFormData((p) => ({ ...p, sasname: "" }));
  }, [formData.samstatus]);

  useEffect(() => {
    const controller = new AbortController();
    (async () => {
      try {
        const response = await fetch(`/backend/api/autofill.php?form=${encodeURIComponent(FORM_NAME)}`, {
          credentials: "include", cache: "no-store", headers: { Accept: "application/json" }, signal: controller.signal,
        });
        const result = await readJson(response);
        if (!response.ok || !result?.success || !result?.found || !result?.data) return;
        const d = result.data;
        setFormData((p) => ({
          ...p,
          entcity: p.entcity || d.city || "", entdist: p.entdist || d.dist || "", entstate: p.entstate || d.state || "", entpin: p.entpin || d.pin || "",
          facity: p.facity || d.city || "", fadist: p.fadist || d.dist || "", fastate: p.fastate || d.state || "", fapin: p.fapin || d.pin || "",
          sacity: p.sacity || d.city || "", sadist: p.sadist || d.dist || "", sastate: p.sastate || d.state || "", sapin: p.sapin || d.pin || "",
        }));
      } catch (error) {
        if (error.name !== "AbortError") console.error("SBI_CA2 autofill error:", error);
      }
    })();
    return () => controller.abort();
  }, []);

  useEffect(() => () => {
    if (pdfUrl?.startsWith("blob:")) URL.revokeObjectURL(pdfUrl);
  }, [pdfUrl]);

  const updateField = (field, raw) => {
    let value = raw;
    if (field.numeric) value = value.replace(/\D/g, "");
    if (field.alphaOnly) value = value.replace(/[^A-Za-z ]/g, "");
    if (field.uppercase || ["entpan","fapan","sapan"].includes(field.name)) {
      value = value.toUpperCase();
    }
    setFormData((p) => ({ ...p, [field.name]: value }));
    setErrors((p) => ({ ...p, [field.name]: "" }));
  };

  const validateField = (field) => {
    if (isDisabled(field)) return "";
    const value = String(formData[field.name] ?? "").trim();
    if (field.required && (field.type === "select" ? !value || value === SELECT : !value)) return `${field.label} is required.`;
    if (field.name === "acno" && value && !/^\d{11}$/.test(value)) return "Account number must contain 11 digits.";
    if (field.alphaOnly && value && !/^[A-Za-z ]+$/.test(value)) return `${field.label} must contain alphabet letters only.`;
    if (["faaadhaarno","saaadhaarno"].includes(field.name) && value && !/^\d{12}$/.test(value)) return "Aadhaar number must contain exactly 12 digits.";
    if (["entpin","fapin","sapin"].includes(field.name) && value && !/^\d{6}$/.test(value)) return "PIN must contain exactly 6 digits.";
    if (["entmobile","famobile","samobile"].includes(field.name) && value && !/^\d{10}$/.test(value)) return "Mobile number must contain 10 digits.";
    if (["entpan","fapan","sapan"].includes(field.name) && value && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) return "Enter a valid PAN number (e.g. ABCDE1234F).";
    if (field.name === "entemail" && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return "Enter a valid email address.";
    return "";
  };

  const validate = (fields) => {
    const next = {};
    fields.forEach((field) => {
      const message = validateField(field);
      if (message) next[field.name] = message;
    });
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const applicableFields = tabs.flatMap((tab) => tab.fields);

  const goNext = () => {
    if (!validate(currentFields)) return;
    const next = currentTab + 1;
    setCurrentTab(next);
    setMaxAllowedTab((p) => Math.max(p, next));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goPrevious = () => {
    setCurrentTab((p) => Math.max(0, p - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLastFieldKeyDown = (event, fieldName) => {
    const last = enabledFields[enabledFields.length - 1]?.name;
    if (fieldName === last && event.key === "Tab" && !event.shiftKey) {
      event.preventDefault();
      nextButtonRef.current?.focus();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate(applicableFields)) {
      const firstInvalid = applicableFields.find((field) => validateField(field));
      const tabIndex = tabs.findIndex((tab) => tab.fields.some((field) => field.name === firstInvalid?.name));
      if (tabIndex >= 0) setCurrentTab(tabIndex);
      return;
    }

    setPdfLoading(true);
    setPdfError("");

    try {
      const body = new FormData();
      Object.entries(formData).forEach(([name, value]) => body.append(name, value === SELECT ? "" : String(value ?? "")));

      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 60000);
      let response;
      try {
        response = await fetch(PDF_ENDPOINT, {
          method: "POST", body, credentials: "include", headers: { Accept: "application/pdf" }, signal: controller.signal,
        });
      } finally {
        clearTimeout(timeout);
      }

      if (!response.ok) throw new Error((await response.text()) || `PDF generation failed (${response.status}).`);
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/pdf")) throw new Error((await response.text()) || "Print.php did not return a PDF file.");

      const url = URL.createObjectURL(await response.blob());
      setPdfUrl((old) => {
        if (old?.startsWith("blob:")) URL.revokeObjectURL(old);
        return url;
      });
      setShowPdf(true);
    } catch (error) {
      setPdfError(error.name === "AbortError" ? "PDF generation timed out." : error.message || "Unable to generate PDF.");
    } finally {
      setPdfLoading(false);
    }
  };

  const renderField = (field) => {
    const disabled = isDisabled(field);
    const error = errors[field.name];

    return (
      <div key={field.name} className="space-y-2">
        <Label htmlFor={field.name}>
          {field.label}{field.required && !disabled && <span className="text-red-500"> *</span>}
        </Label>

        {field.type === "select" ? (
          <select
            id={field.name}
            name={field.name}
            value={formData[field.name]}
            disabled={disabled}
            onChange={(e) => updateField(field, e.target.value)}
            onKeyDown={(e) => handleLastFieldKeyDown(e, field.name)}
            className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm disabled:cursor-not-allowed disabled:opacity-50 ${error ? "border-red-500" : ""}`}
          >
            <option value={SELECT}>SELECT</option>
            {(field.options || []).map(([value,label]) => <option key={`${field.name}-${value}`} value={value}>{label}</option>)}
          </select>
        ) : (
          <Input
            id={field.name}
            name={field.name}
            type={field.type || "text"}
            value={formData[field.name]}
            maxLength={field.maxLength}
            disabled={disabled}
            placeholder={field.label}
            className={error ? "border-red-500" : ""}
            onChange={(e) => updateField(field, e.target.value)}
            onKeyDown={(e) => handleLastFieldKeyDown(e, field.name)}
          />
        )}

        {error && <p className="text-sm text-red-500">{error}</p>}
      </div>
    );
  };

  if (showPdf && pdfUrl) {
    return <PdfViewerContainer pdfUrl={pdfUrl} title="SBI Current Account Opening Form" onBack={() => setShowPdf(false)} />;
  }

  const isLastTab = currentTab === tabs.length - 1;

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="mx-auto max-w-7xl">
        <Card className="mb-6">
          <CardHeader>
            <CardTitle className="text-3xl">🏦 SBI Current Account Opening Form</CardTitle>
            <p className="text-muted-foreground">Complete each applicable section and submit directly from the final tab.</p>
          </CardHeader>
        </Card>

        <div className="mb-8 grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))" }}>
          {tabs.map((tab,index) => (
            <Button
              key={tab.title}
              type="button"
              variant={currentTab === index ? "default" : "outline"}
              disabled={index > maxAllowedTab}
              onClick={() => setCurrentTab(index)}
            >
              {index + 1}. {tab.title}
            </Button>
          ))}
        </div>

        <Card>
          <CardHeader><CardTitle>{activeTab.title}</CardTitle></CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
              {currentFields.map(renderField)}
            </div>
          </CardContent>
        </Card>

        {pdfError && <p className="mt-4 rounded-lg border border-red-300 bg-red-50 p-3 text-red-700">{pdfError}</p>}

        <div className="mt-6 flex items-center justify-between">
          <Button type="button" variant="outline" onClick={goPrevious} disabled={currentTab === 0}>← Previous</Button>
          {isLastTab ? (
            <Button type="button" ref={nextButtonRef} onClick={handleSubmit} disabled={pdfLoading}>
              {pdfLoading ? "Generating PDF..." : "Submit & Open PDF"}
            </Button>
          ) : (
            <Button type="button" ref={nextButtonRef} onClick={goNext}>Next →</Button>
          )}
        </div>
      </div>
    </div>
  );
}
